import { OPTIMIZELY_FEATURE } from '@/optimizely/constants'
import type { OptimizelyHookResult } from '@/optimizely/types'
import { useOptimizelyFeature } from '@/optimizely/utils'

export const useNCAARegionsFeature = (isDesktop?: boolean): OptimizelyHookResult => {
    return useOptimizelyFeature(
        isDesktop ? OPTIMIZELY_FEATURE.ncaaRegionsDesktop : OPTIMIZELY_FEATURE.ncaaRegionsMobile,
    )
}
